"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiLayoutMap = exports.SimpleHeaderLayoutMap = void 0;
var simple_header_layout_1 = require("./internal/simple-header-layout");
Object.defineProperty(exports, "SimpleHeaderLayoutMap", { enumerable: true, get: function () { return simple_header_layout_1.SimpleHeaderLayoutMap; } });
var multi_layout_1 = require("./internal/multi-layout");
Object.defineProperty(exports, "MultiLayoutMap", { enumerable: true, get: function () { return multi_layout_1.MultiLayoutMap; } });
